import { getWebStoreApiClient } from '@gn-audio/core/auth/web-store-api';

import { getAccountDetails } from './get-webstore-account-details';

export type PostLoginActionType = 'transferBasket' | 'checkout';
export interface PostLoginAction {
  type: PostLoginActionType;
  params?: unknown;
}
export const POST_LOGIN_ACTIONS_KEY = 'POST_LOGIN_ACTION';

export const logIn = async (postLoginActions: PostLoginAction[]): Promise<void> => {
  const webstoreClient = getWebStoreApiClient();
  const account = webstoreClient.account;
  if (!account) {
    savePostLoginActions(postLoginActions);
    await webstoreClient.signIn();
  } else {
    await getAccountDetails();
  }
};

export const getPostLoginActions = (): PostLoginAction[] => {
  return JSON.parse(localStorage.getItem(POST_LOGIN_ACTIONS_KEY) ?? '[]');
};

export const savePostLoginActions = (actions: PostLoginAction[]) => {
  localStorage.setItem(POST_LOGIN_ACTIONS_KEY, JSON.stringify(actions));
};
